export default {
    user : null,
    authenticated: false,
    token: null
};
